import { useCallback } from 'react';
import { EndPoints } from 'src/config';
import { useFetcher } from 'src/hooks/useFetcher';
import { UpdateUserInputs } from '../users.types';

type PatchUserResponse = {
  count: number;
};
export const useSubmitUserUpdate = () => {
  const { data, isLoading, error, fetcher } = useFetcher<PatchUserResponse | null>(null);

  const patchUser = useCallback(
    (userId: string, data: UpdateUserInputs) => {
      fetcher(EndPoints.dashboardUserUpdate.replace(':id', userId), {
        requiredToken: true,
        method: 'PATCH',
        body: {
          ...data,
          city: data?.city?.value ?? undefined,
        },
      });
    },
    [fetcher],
  );

  return {
    patchUser,
    isLoading,
    data,
    error,
    userUpdated: !!data?.count,
  };
};
